import type { JSX } from 'react'
import type { BalanceRow } from '../api'
import { isNegative, monthLabel, yen } from '../format'

// Computed cash flow vs the audited bank balance, monthly, forever.
//
// This is a product surface, not a test (evaluation §7.3). Drift from tax
// float and timing is expected; what changed is that it is now VISIBLE,
// replacing the sheet's habit of seeding whichever balance was handy — the
// workbook carries three different April-2026 balances spreading ¥1.69M.

export function BalanceReconciliation({ rows }: { rows: BalanceRow[] }): JSX.Element {
  if (rows.length === 0) {
    return (
      <section className="panel">
        <h2>Bank reconciliation</h2>
        <p className="notice">
          No audited balances recorded yet — this table fills in as month-end balances are entered.
        </p>
      </section>
    )
  }

  return (
    <section className="panel">
      <h2>Bank reconciliation</h2>
      <div className="scroller">
        <table>
          <thead>
            <tr>
              <th scope="col">Month</th>
              <th scope="col">Audited</th>
              <th scope="col">Computed</th>
              <th scope="col">Drift</th>
              <th scope="col">Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.month}>
                <th scope="row">{monthLabel(row.month)}</th>
                <td>{yen(row.auditedBalance)}</td>
                <td>{yen(row.computedBalance)}</td>
                <td className={isNegative(row.drift) ? 'negative' : ''}>{yen(row.drift)}</td>
                <td className="muted">{row.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
